var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M984.62,472.62H551.38V39.38C551.38,17.64,533.74,0,512,0c-21.74,0-39.38,17.64-39.38,39.38v433.23H39.38C17.64,472.62,0,490.26,0,512c0,21.74,17.64,39.38,39.38,39.38h433.23v433.23c0,21.74,17.64,39.38,39.38,39.38c21.74,0,39.38-17.64,39.38-39.38V551.38h433.23c21.74,0,39.38-17.64,39.38-39.38C1024,490.26,1006.36,472.62,984.62,472.62z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.2e7cd579876ac17b87dfd91ff7658419.svg";
export { ForwardRef as ReactComponent };